import PackageTenderItem from '@/models/PackageTenderItem';
import PackageTenderItemService from '@/services/PackageTenderItemService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const usePackageTenderItemsStore = defineStore('packageTenderItems', {
  state: () => ({}),

  getters: {
    models: () => useRepo(PackageTenderItem),
  },

  actions: {
    async store(tenderId: Id, signedParams: unknown, form: ApiRequests['api.v1.subcontractor.tenders.items.store']) {
      const [data, error] = await PackageTenderItemService.store(tenderId, signedParams, form);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },
  },
});
